module.exports = __webpack_public_path__ + "static/media/paginationButton.b01d2970.svg";